export default __webpack_public_path__ + "static/media/viguetas.26b1b0b5.png";